/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState, useContext } from 'react';
import { Formik, Form } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'ypf-pas-general-ui-components';
import { BiDetail } from 'react-icons/bi';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

import {
  getMultipleDraft,
  updateMultipleDraft,
  postCreateMultipleRequest
} from '../../adapters/createServiceRequest/createServiceRequestAdapter';
import { getNotification } from '../../services/adminContracts';
// Setps of Form
import { useFilesContext } from '../../context/FilesProvider';
import LoaderContext from '../../context/LoaderProvider';
import FloatingButton from '../FloatingButton/FloatingButton';
import useToast from '../../hooks/useToast';
import { errorNotSupervisor } from '../../constants/constants';
import ModalApplyTemplate from '../Templates/RequestTemplate/ModalApplyTemplate/ModalApplyTemplate';
import MainTitle from '../MainTitle/MainTitle';
import { checkDuplicityService, deleteDraft } from '../../services/serviceRequest';
import DuplicatedRequestModal from '../DuplicatedRequestModal/DuplicatedRequestModal';

import ModalsCreate from './ModalsCreate/ModalsCreate';
import ListOfAccordions from './ServiceForm/ListOfAccordions/ListOfAccordions';
import { initialValuesSDS, stepEnum } from './Constants';
import ButtonsCreate from './ButtonCreate/ButtonCreate';
import validationSchema from './ValidationSchemaCSR';
import UbicationForm from './UbicationForm/UbicationForm';

import './CreateServiceRequest.scss';

const getEventSigla = (values) =>
  values?.ubication?.event?.sigla ||
  values?.imputationObject?.wells[0]?.event?.sigla ||
  values?.ubication?.operationType?.sigla ||
  '';

const getTeamLabel = (values) =>
  values?.ubication?.team?.label || values?.imputationObject?.wells[0]?.team?.label;

const getUbicationName = (values) =>
  `${values?.ubication.ubication?.nombre} ${getEventSigla(values)} ${getTeamLabel(values)}`;

const CreateServiceRequest = () => {
  const [showTwoStep, setShowTwoStep] = useState(false);
  const [step, setStep] = useState(1);
  const [showButtonMenu, setShowButtonMenu] = useState(true);
  const [showModalExit, setShowModalExit] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [notificationOptions, setNotificationOptions] = useState([]);
  const [errorModal, setErrorModal] = useState({});
  const [deletedServices, setDeletedServices] = useState([]);
  const [showModalApplyTemplate, setShowModalApplyTemplate] = useState(false);
  const [isApplyTemplateRequest, setIsApplyTemplateRequest] = useState(false);
  const [duplicateData, setDuplicateData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isAutocomplete, setIsAutocomplete] = useState(false);
  const [autoCompletWells, setAutoCompletWells] = useState(false);
  const form = useRef(null);

  const history = useHistory();
  // Si nos redirijimos a la creacion de plantillas desde la creacion de una solicitud
  // abrimos el modal al volver, le mandamos por el cuerpo del useLocation esta data
  // Si nos dirigimos desde el replicarPlantilla, vamos a recibir el id de la solicitud
  // la vamos a desestructurar y cargar la data necesaria
  const { openTemplateMOdal, idSDSToReply, previusPath } = useLocation();

  const { setNewToast } = useToast();

  const { setLoader } = useContext(LoaderContext);
  const { postFilesClientMultiple, setDataAdjuntos, copyExistingFiles } = useFilesContext();
  const isCreate = history.location.pathname.includes('createMultiple');
  const { id: draftId } = useParams();

  const setShowErrorModal = (showFlag) => {
    const newErrorModal = {
      ...errorModal,
      show: showFlag
    };

    if (!showFlag) newErrorModal.accordionsWithError = [];
    setErrorModal(newErrorModal);
  };

  const fetchNotification = async (idBusinessUnit, contractNumber) => {
    const notification = await getNotification(idBusinessUnit, contractNumber);

    setNotificationOptions(notification.data.opciones);
  };

  const showCreatedDeletedServicesToasts = (response) => {
    const sdsNumbers = response.solicitudesServicio?.map((sds) => sds.numero);

    setNewToast({
      type: 'SUCCESS',
      message: `${response.mensaje || 'Se han actualizado las solicitudes:'}\nN° ${sdsNumbers.join(
        '\nN° '
      )}`
    });
    if (response?.numeroEliminados?.length) {
      setNewToast({
        type: 'ERROR',
        message: `${response.mensajeEliminados}\nN° ${response.numeroEliminados.join('\nN° ')}`
      });
    }
  };

  const postCreteRequestFiles = async (accordions, solicitudes) => {
    solicitudes.map(async (solicitud, index) => {
      await postFilesClientMultiple(accordions[index], solicitud?.id);
      if (isApplyTemplateRequest)
        await copyExistingFiles(
          accordions[index],
          // idOrigen
          accordions[index]?.templeteRequestId,
          // idDestino
          solicitud?.id,
          // isDrwaw
          false,
          isApplyTemplateRequest
        );
      if (idSDSToReply)
        await copyExistingFiles(
          accordions[index],
          // idOrigen
          accordions[index]?.serviceRequestId,
          // idDestino
          solicitud?.id,
          // isDrwaw
          false,
          // isApplyTemplateRequest
          false,
          // isReplyRequest
          true
        );
    });
  };

  const getDraftData = (id, isApplyTemplateRequestParam) => {
    setLoader(true);
    const isReplyRequest = !!idSDSToReply;

    getMultipleDraft(id, isReplyRequest, false, false, isApplyTemplateRequestParam)
      .then(async (response) => {
        if (response?.accordions[0]?.provider?.providers?.length) {
          const providerData = response.accordions[0].provider.providers[0];

          fetchNotification(providerData.businessUnit.id, providerData.contract.nombre);
        }
        setShowTwoStep(true);
        setStep(stepEnum.services);
        form.current.setValues(response);
        const allAttachments = response?.accordions.map((acc) => acc.attachments).flat();

        setDataAdjuntos(allAttachments);
        setLoader(false);
        if (isApplyTemplateRequestParam) setIsApplyTemplateRequest(true);
      })
      .catch((err) => {
        setLoader(false);
        setNewToast({
          type: 'ERROR',
          message: err.message || 'Ocurrió un error al intentar recuperar el borrador'
        });
      });
  };

  const deleteDraftButton = async () => {
    setLoader(true);
    deleteDraft(draftId)
      .then((data) => {
        if (data.status === 200) {
          history.push('/');
          setNewToast({
            type: 'SUCCESS',
            message: 'El borrador se eliminó correctamente'
          });
        }
        setLoader(false);
      })
      .catch(() => {
        setNewToast({
          type: 'ERROR',
          message: 'Ocurrió un problema al intentar eliminar el borrador'
        });
        setLoader(false);
      });
  };

  const postServiceRequest = async (values, stateSave) => {
    setLoader(true);
    try {
      const response = await postCreateMultipleRequest(
        {
          ...values,
          stateSave
        },
        deletedServices,
        idSDSToReply || isApplyTemplateRequest,
        isApplyTemplateRequest
      );

      await postCreteRequestFiles(values?.accordions, response?.solicitudesServicio);

      setLoader(false);
      history.push('/');
      showCreatedDeletedServicesToasts(response);
    } catch (err) {
      setLoader(false);
      if (err.message.includes(errorNotSupervisor)) {
        // Le quito la parte del mensaje de errorNotSupervisor
        // y convierto en array los servicios que le siguen y están separados por comas.
        // Cada servicio viene de la forma "fechaProbableRealizacion - nombreServicio"
        const accordionsWithError = err.message.slice(19).split(', ');

        setErrorModal({
          show: true,
          accordionsWithError
        });
      } else {
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
      }
    }
  };

  const handleCheckDuplicity = async (values, stateSave) => {
    const idsEventoPozoValueConst = values?.imputationObject?.wells
      ?.map((well) => well?.event?.eventoPozoId)
      .filter((idWell) => idWell !== undefined && idWell !== null);

    const ubicacionNombreConst = getUbicationName(values);

    // Divide el string en palabras , filtra las palabras para eliminar "undefined", luego une las palabras en un nuevo string
    const ubicacionNombreConstClean = ubicacionNombreConst
      .split(' ')
      .filter((palabra) => palabra.toLowerCase() !== 'undefined')
      .join(' ');

    try {
      setLoader(true);
      const services = values?.accordions.map((acc) => ({
        idServicio: acc.service.service.id,
        idProveedor: acc.provider?.providers[0]?.provider?.id,
        // contract names may have "(vencido)" in label
        contrato: Number(acc.provider?.providers[0]?.contract.nombre.split(' ')[0])
      }));
      const body = {
        idSolicitud: null,
        tipoAsignacionEnum: 1,
        ubicacion: {
          tipoUbicacionEnum: values?.ubication?.ubicationType?.id,
          ubicacionNombre: ubicacionNombreConstClean
        },
        idsEventoPozo: idsEventoPozoValueConst.length === 0 ? null : idsEventoPozoValueConst,
        servicios: services
      };
      const res = await checkDuplicityService(body);

      if (res.existenDuplicados) {
        setDuplicateData(res.solicitudesDuplicadas);
        setShowModal(true);
        setLoader(false);
      } else {
        postServiceRequest(values, stateSave);
      }
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    } finally {
      setLoader(false);
    }
  };

  // duplicity is checked only in services with one provider, sds or gsds

  const handleVerifyCheckDuplicityConditions = async (values, stateSave) => {
    const servicesToCheck = values?.accordions.filter(
      (acc) => acc.provider?.providers?.length === 1
    );
    const valuesToCheck = {
      accordions: servicesToCheck,
      imputationObject: values?.imputationObject,
      ubication: values?.ubication,
      ...values
    };

    if (servicesToCheck.length > 0) {
      handleCheckDuplicity(valuesToCheck, stateSave);
    } else {
      postServiceRequest(values, stateSave);
    }
  };

  useEffect(() => {
    if (isCreate) {
      setAutoCompletWells(true);
      setDataAdjuntos([]);
    } else {
      setIsAutocomplete(true);
      setAutoCompletWells(false);
      getDraftData(draftId);
    }
  }, []);

  const buttonsRef = useRef();

  useEffect(() => {
    let observer;

    const onObserve = (entries) => {
      const buttons = entries[0];

      if (buttons.isIntersecting) {
        setShowButtonMenu(false);
      } else {
        setShowButtonMenu(true);
      }
    };

    Promise.resolve(
      typeof IntersectionObserver !== 'undefined'
        ? IntersectionObserver
        : import('intersection-observer')
    ).then(() => {
      observer = new IntersectionObserver(onObserve, {
        rootMargin: '100px'
      });

      if (buttonsRef.current) {
        observer.observe(buttonsRef.current);
      }
    });

    return () => observer?.disconnect();
  }, [buttonsRef]);

  const updateDraft = async (values, stateSave) => {
    setLoader(true);
    try {
      const response = await updateMultipleDraft(
        values.gsdsNumber,
        {
          ...values,
          stateSave
        },
        deletedServices
      );

      setLoader(false);
      history.push('/');
      showCreatedDeletedServicesToasts(response);
    } catch (err) {
      setLoader(false);
      if (err.message.includes(errorNotSupervisor)) {
        const accordionsWithError = err.message.slice(19).split(', ');

        setErrorModal({
          show: true,
          accordionsWithError
        });
      } else {
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
      }
    }
  };

  const addDeletedServiceRequest = (serviceRequest) => {
    if (serviceRequest?.serviceRequestId)
      setDeletedServices((prevState) => [
        ...prevState,
        {
          id: serviceRequest?.serviceRequestId,
          eliminado: true
        }
      ]);
  };

  const handleReplicateView = (id) => {
    getDraftData(id);
    setAutoCompletWells(true);
    setIsAutocomplete(true);
  };

  useEffect(() => {
    if (openTemplateMOdal) setShowModalApplyTemplate(true);
  }, openTemplateMOdal);

  useEffect(() => {
    // SI hay idSDSToReply siginifica que estamos en la vista replicar y tenemos que traer los datos
    // El valor isAutoComplete sirve para identificar si una plantilla es para editar o borrador
    // Se la pasamos al ubicationForm y lo usa useUbicationForma para evitar volver a consultar
    if (idSDSToReply) {
      handleReplicateView(idSDSToReply);
    }
  }, [idSDSToReply]);

  const buttonsSection = ({ values }) => (
    <div className="btn-container-end row justify-content-center" ref={buttonsRef}>
      <ButtonsCreate
        createServiceRequest={() => {
          if (isCreate) handleVerifyCheckDuplicityConditions(values, false);
          if (!isCreate) updateDraft(values, false);
        }}
        isReplyRequest={!!idSDSToReply}
        saveDraft={async () => {
          if (isCreate) {
            handleVerifyCheckDuplicityConditions(values, true);
          }
          if (!isCreate) {
            updateDraft(values, true);
          }
        }}
        setShowModalDelete={setShowModalDelete}
        setShowModalExit={setShowModalExit}
      />
    </div>
  );

  return (
    <Formik
      enableReinitialize
      initialValues={initialValuesSDS}
      innerRef={form}
      validationSchema={validationSchema}
    >
      {({ values }) => (
        <Form>
          <div className="container container-create-service-request">
            <div className="d-flex align-items-center justify-content-between">
              <MainTitle nombre="Solicitud de servicio" previusPath={previusPath} />
              <Button
                className="button_template"
                colorIcon="primary"
                fontSizeLabel="15px"
                icon={BiDetail}
                iconRight
                label="Plantillas"
                onClick={() => setShowModalApplyTemplate(true)}
                sizeIcon="18px"
                type="button"
                variant="light-gray"
                widthButton="180px"
              />
            </div>
            <UbicationForm
              autocompletWells={autoCompletWells}
              createSDS
              fatherStep={step}
              isApplyTemplateRequest={isApplyTemplateRequest}
              isAutocomplete={isAutocomplete}
              isDraft={!!draftId}
              refreshWells={isApplyTemplateRequest}
              setFatherStep={setStep}
              setIsApplyTemplateRequest={setIsApplyTemplateRequest}
              setShowNextStep={setShowTwoStep}
            />
            {showTwoStep && (
              <ListOfAccordions
                addDeletedServiceRequest={addDeletedServiceRequest}
                isApplyTemplateRequest={isApplyTemplateRequest}
                isAutocomplete={isAutocomplete}
                notificationOptions={notificationOptions}
                setShow={setShowTwoStep}
                setStep={setStep}
              />
            )}
            {buttonsSection({ values })}
            {showButtonMenu && (
              <FloatingButton isOpen>
                <div className="w-100 d-flex justify-content-between flex-gap-1">
                  <ButtonsCreate
                    createServiceRequest={() => {
                      if (isCreate) handleVerifyCheckDuplicityConditions(values, false);
                      if (!isCreate) updateDraft(values, false);
                    }}
                    saveDraft={() => {
                      if (isCreate) handleVerifyCheckDuplicityConditions(values, true);
                      if (!isCreate) updateDraft(values, true);
                    }}
                    setShowModalDelete={setShowModalDelete}
                    setShowModalExit={setShowModalExit}
                  />
                </div>
              </FloatingButton>
            )}
            <ModalsCreate
              deleteDraft={deleteDraftButton}
              errorModal={errorModal}
              setShowErrorModal={setShowErrorModal}
              setShowModalDelete={setShowModalDelete}
              setShowModalExit={setShowModalExit}
              showModalDelete={showModalDelete}
              showModalExit={showModalExit}
            />
            <ModalApplyTemplate
              applyTemplateRequest={getDraftData}
              idDraw={draftId}
              isDraw={!isCreate}
              setShow={setShowModalApplyTemplate}
              show={showModalApplyTemplate}
            />
            <DuplicatedRequestModal
              data={duplicateData}
              handlePrimary={() => {
                postServiceRequest(values, false);
              }}
              setShowModal={setShowModal}
              showModal={showModal}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CreateServiceRequest;
